import React from 'react';

const GridIcon = ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25a2.25 2.25 0 01-2.25 2.25H15.75a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H15.75a2.25 2.25 0 01-2.25-2.25v-2.25z" />
    </svg>
);

const ListIcon = ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
);

const ViewToggle = ({ mode, onChange }) => {
    return (
        <div className="flex items-center gap-1 p-1 bg-[var(--bg-tertiary)]/50 backdrop-blur-sm border border-[var(--border-subtle)] rounded-full shadow-sm">
            <button
                onClick={() => onChange('grid')}
                className={`p-2 rounded-full transition-all duration-200 ${mode === 'grid'
                    ? 'bg-[var(--text-main)] text-[var(--bg-main)] shadow-md scale-105'
                    : 'text-[var(--text-dim)] hover:text-[var(--text-main)] hover:bg-[var(--bg-tertiary)]'
                    }`}
                title="Grid View"
            >
                <GridIcon className="w-4 h-4" />
            </button>
            <button
                onClick={() => onChange('list')}
                className={`p-2 rounded-full transition-all duration-200 ${mode === 'list'
                    ? 'bg-[var(--text-main)] text-[var(--bg-main)] shadow-md scale-105'
                    : 'text-[var(--text-dim)] hover:text-[var(--text-main)] hover:bg-[var(--bg-tertiary)]'
                    }`}
                title="List View"
            >
                <ListIcon className="w-4 h-4" />
            </button>
        </div>
    );
};

export default ViewToggle;
